import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=72e0ab54&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=72e0ab54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0ab54",
  null
  
)

export default component.exports